import React, { useContext } from "react";
import { NotificationsContext } from "../Contexts/NotificationsContext";
import { Toast, ToastContainer } from "react-bootstrap";
import "../style/Notification.css";

function Notification() {
  const { notifications, removeNotification } = useContext(NotificationsContext);
  const timeToShowSuccessNotification = 10000;
  const timeToShowErrorNotification = 30000;

  return (
    <div>
      <ToastContainer position="top-end" className="p-3 position-fixed">
        {notifications.map((notification) => (
          <Toast
            onClose={() => removeNotification(notification.id)}
            show={notification.show}
            delay={notification.type === "Success" ? timeToShowSuccessNotification : timeToShowErrorNotification}
            autohide
          >
            <Toast.Header
              style={{ backgroundColor: notification.type === "Success" ? "#5dbf5a" : "#FF383F", color: "black" }}
            >
              <span className="me-auto">{notification.type}</span>
            </Toast.Header>
            <Toast.Body>{notification.description}</Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
    </div>
  );
}

export default Notification;
